// @ts-nocheck

import { useState, useEffect, useRef, useMemo } from 'react';
import Editor, { BtnBold, BtnItalic, Toolbar } from 'react-simple-wysiwyg';

import { Spin } from 'antd';
import type { MultilanguageState } from '../../hooks/useMultilanguageState';
import { useAppSelector } from '../../store';
import './editor.scss';
import commonStyles from '../../style/components/common.module.scss';


interface HTMLEditorProps {
  value?: string | MultilanguageState<string>;
  onChange?: (data: string) => void;
  placeholder?: string;
  label?: string;
  currentLanguage?: string;
  error?: boolean | MultilanguageErrorState;
  errorMessage?: string;
  required?: boolean;
}

export default function HTMLEditor({
  value = '',
  onChange,
  placeholder,
  label,
  currentLanguage,
  error = false,
  errorMessage,
  required = false,
}: HTMLEditorProps) {
  const editorContainerRef = useRef(null);
  const languages = useAppSelector((state) => state.config.languages);

  const isLoading = false; // TODO: implement loading state for editor
  const hasError = typeof error === 'object' ? (currentLanguage ? !error[currentLanguage] : false) : error;

  return (
    <div className={commonStyles.container}>
      {label && (
        <label className={commonStyles.label}>
          {label}
          {required && <span style={{ color: 'var(--color-success)' }}> *</span>}
        </label>
      )}

      <div className={`${hasError ? 'error' : ''}`}>
        {isLoading && (
          <div className={` ${hasError ? 'error' : ''}`}>
            <Spin size="default" />
          </div>
        )}
      </div>

      <Editor
        containerProps={{
          className: `${hasError ? 'error' : ''}`
        }}
        value={currentLanguage ? value[currentLanguage] : value}
        onChange={(val) => {
          let newValue = val.target.value.replaceAll('<div', '<p').replaceAll('</div', '</p');
          if (newValue && !newValue.startsWith('<p>')) {
            newValue = '<p>' + newValue.replace('<p>', '</p><p>');
          }

          if (currentLanguage) {
            onChange({ ...(value || {}), [currentLanguage]: newValue });
          } else {
            onChange(newValue);
          }
        }}
      >
        {/* <Toolbar>
          <BtnBold />
          <BtnItalic />
        </Toolbar> */}
      </Editor>
      {/* {currentLanguage ? (
        languages.map((lang) => {
          if (currentLanguage !== lang.LanguageId) return null;
          return (
            <EditorInstance
              key={'editor-' + lang.LanguageId}
              data={value[lang.LanguageId] || ''}
              onChange={(data) => {
                onChange({ ...(value || {}), [lang.LanguageId]: data });
              }}
            />
          );
        })
      ) : (
        <EditorInstance
          value={value}
          onChange={onChange}
        />
      )} */}
      {hasError && <span className={commonStyles.errorMessage}>{errorMessage || 'This field is mandatory.'}</span>}
    </div>
  );
}
